import React from "react";
import Page from "./Page";
import { monYearFormat } from "../utils";

const Day = ({ title, date, desc, img }) => (
  // we can safely "dangerously set HTML" because we don't have "user"
  // generated content, just static copve "user" generated content, just
  // static copy
  <Page background={`url(${img}) rgba(0, 0, 0, 0.633)`}>
    <div className="day">
      <h1 className="headline">
        <span className="date">{monYearFormat(date)}</span>
        <span
          className="title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></span>
      </h1>
      <p className="description" dangerouslySetInnerHTML={{ __html: desc }}></p>
    </div>
  </Page>
);

export default Day;
